// extracted by mini-css-extract-plugin
var _1 = "vy9AKdBdBooP8B2e1lTf";
var _2 = "SA5XxMUXGETxvPhUczxx";
var _3 = "aL1wcg_ymTt3yyLzW73r";
var _4 = "b3e0_8Tmox38cFMmEjEh";
var _5 = "FILwTaPgfsq2qQ8T0Hbx";
export { _1 as "dark", _2 as "light", _3 as "scrollProgressIndicator", _4 as "scrollProgressLabel", _5 as "scrollProgressLine" }
